module.exports = __webpack_public_path__ + "img/table.0bbacc5e.png";